export default {
  en: {
    category: 'Category',
    period: 'Period',
    value: 'Value',
    total: 'Total',
  },
};
